var $newsletterContent = $('.newsletter');
var $siteFooter = $('.site-footer');
var halfWay = $('body').height() / 4;

$(window).scroll(function() {
    var scrollBottom = $(window).scrollTop() + $(window).height();

    //Open the box half way through the page
    if (scrollBottom >= halfWay && !$newsletterContent.hasClass('is-visible')) {
        $newsletterContent.addClass('is-visible');
    } else if (scrollBottom <= halfWay && $newsletterContent.hasClass('is-visible')) {
        $newsletterContent.removeClass('is-visible');
    }
});
